module.exports = __webpack_public_path__ + "static/prices-realized-mobile-hero-e4ba5b477963a2d61b2affde9d1427fa.png";